import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./pages/Home";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import Create from "./pages/Create";
import Explore from "./pages/Explore";
import TierList from "./pages/TierList";
import CssBaseline from "@mui/material/CssBaseline";
import initialData from "./initialData";
import MyTemplates from "./pages/MyTemplates";
import MyTierLists from "./pages/MyTierLists";
import { useState, useEffect } from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { collection, getDocs, query } from "firebase/firestore";
import { db } from "./firebase.config";
import { toast } from "react-toastify";
import Drafts from "./pages/Drafts";
import CreateNewTierList from "./pages/CreateNewTierList";
import EditDraft from "./pages/EditTierList";
import EditTemplate from "./pages/EditTemplate";
import CreateGenre from "./pages/CreateGenre";
import CreateTopic from "./pages/CreateTopic";

import { getAuth } from "firebase/auth";

function App() {
  const [appState, setAppState] = useState(initialData);
  const [genres, setGenres] = useState({});
  const auth = getAuth();

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        // Get Genres
        // Get Reference
        const genreRef = collection(db, "formGenres");

        // Create a query
        const q = query(genreRef);

        // Execute query
        const querySnap = await getDocs(q);

        let newGenres = {};

        querySnap.forEach((doc) => {
          const docData = doc.data();
          const itemObject = {
            [doc.id]: {
              name: docData.name,
              key: docData.key,
              topicsRef: docData.topicsRef,
            },
          };
          newGenres = { ...newGenres, ...itemObject };
          return;
        });
        setGenres(newGenres);
      } catch (error) {
        toast.error("Could not fetch Genres");
      }
    };
    fetchGenres();

    const setUser = () => {
      auth.onAuthStateChanged((myUser) => {
        if (myUser) {
          setAppState((prevState) => ({
            ...prevState,
            currentUser: myUser,
          }));
        } else {
          setAppState((prevState) => ({
            ...prevState,
            currentUser: null,
          }));
        }
      });
      // if (auth.currentUser) {
      //   setAppState((prevState) => ({
      //     ...prevState,
      //     currentUser: auth.currentUser,
      //   }));
      // } else {
      //   setAppState((prevState) => ({
      //     ...prevState,
      //     currentUser: null,
      //   }));
      // }
    };

    setUser();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <CssBaseline />
      <Router>
        <Navbar setAppState={setAppState} appState={appState} />
        <main
          style={{
            marginBottom: "50px",
          }}
        >
          <Routes>
            <Route
              path="/"
              element={<Home setAppState={setAppState} />}
            ></Route>
            <Route
              path="/tierlist/drafts"
              element={
                <Drafts
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route
              path="/tierlist/new"
              element={
                <CreateNewTierList
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route path="/tierlist/:tierListId" element={<TierList />} />

            <Route path="/profile" element={<PrivateRoute />}>
              <Route path="/profile" element={<Profile />} />
            </Route>

            <Route path="/mytierlists" element={<PrivateRoute />}>
              <Route
                path="/mytierlists"
                element={
                  <MyTierLists
                    genres={genres}
                    setGenres={setGenres}
                    appState={appState}
                    setAppState={setAppState}
                  />
                }
              />
            </Route>

            <Route path="/create" element={<PrivateRoute />}>
              <Route
                path="/create"
                element={
                  <Create
                    genres={genres}
                    setGenres={setGenres}
                    appState={appState}
                    setAppState={setAppState}
                  />
                }
              ></Route>
            </Route>
            <Route
              path="/genre/create"
              element={
                <CreateGenre
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route
              path="/topic/create"
              element={
                <CreateTopic
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route
              path="/topic/mytemplates"
              element={
                <MyTemplates
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route
              path="/topic/edit/:templateId"
              element={
                <EditTemplate
                  genres={genres}
                  setGenres={setGenres}
                  appState={appState}
                  setAppState={setAppState}
                />
              }
            ></Route>
            <Route
              path="/tierlist/edit/:draftId"
              element={
                <EditDraft appState={appState} setAppState={setAppState} />
              }
            />
            <Route
              path="/explore"
              element={<Explore genres={genres} />}
            ></Route>
            <Route path="/sign-up" element={<SignUp />}></Route>
          </Routes>
        </main>
      </Router>
      <Footer
        description="A tier list application created using React & Firebase"
        title="React Tier List App"
      />
      <ToastContainer />
    </>
  );
}

export default App;
